<template>
  <div class="flex align-center items-center justify-center">
    <button
      class="flex items-center justify-center mr-3 my-8"
      :class="{
        'opacity-50 cursor-not-allowed pointer-events-none': !(loaded && loadedLabs),
        blinking: isDownloading,
        'pointer-events-none': !loaded && !loadedLabs,
      }"
      @click="generateReport()"
      :disabled="!(loaded && loadedLabs)"
    >
      <CheckSquareIcon class="w-4 h-4 mr-1" />
      {{ $t("views.pdf.text1") }}
    </button>
  </div>
  <div class="w-7/12 mx-auto bg-white rounded-2xl document pt-9">
    <div class="pb-9 px-20" ref="document">
      <div class="text-custom-gray-6 w-full">
        <div class="items-baseline text-center boxx">
          <p class="text-lg text-custom-gray-7 font-black">
            <!-- ALA: hacerlo dinamico -->
            {{ $t("views.pdf.text2") }}
          </p>
        </div>
        <div class="flex mt-16 text-lg boxx">
          <div class="bg-custom-green-1 w-1 mr-5"></div>
          <span class="font-bold">{{ $t("views.pdf.text3") }}</span>
        </div>
        <div class="grid grid-cols-3 mt-8 boxx">
          <div>
            <div class="font-bold">{{ $t("views.pdf.text4") }}</div>
            <div>{{ user.session_name }}</div>
          </div>
          <div>
            <div class="font-bold">{{ $t("views.pdf.text5") }}</div>
            <div>{{ user.num_analysis }}</div>
          </div>
          <div>
            <div class="font-bold">{{ $t("views.pdf.text6") }}</div>
            <div>{{ today }}</div>
          </div>
        </div>
        <div class="flex mt-14 text-lg boxx">
          <div class="bg-custom-green-1 w-1 mr-5"></div>
          <!-- FALTA: Hacer titulo dinamico -->
          <span class="font-bold">{{ $t("views.pdf.text7") }}</span>
        </div>
        <template v-if="loaded && loadedLabs">
          <!-- Conclusiones -->
          <div class="pl-10 pt-8 boxx">
            <div class="flex items-center">
              <div class="w-2 h-2 bg-gray-600 rounded-full mr-5 circlesinrelleno"></div>
              <span class="text-lg font-bold w-full">{{ $t("views.pdf.text30") }}</span>
            </div>
            <div class="pl-10 pt-8">
              <div class="flex">
                <div
                  class="w-2 h-2 border-1 border-gray-600 bg-transparent rounded-full mr-5 mt-2 circlesinrelleno"
                ></div>
                <span class="w-full">{{ $t("views.pdf.text31") }}</span>
              </div>
            </div>
          </div>
          <!--   Solo aparece si es paltaforma: Texto a tener en cuenta:
              <div class="pl-10 pt-3">
                            <div class="flex">
                              <div
                                class="w-2 h-2 border-1 border-gray-600 bg-transparent rounded-full mr-5 mt-2"
                              ></div>
                              <span class="w-full">{{ $t("views.pdf.text32") }}</span>
                            </div>
              </div> -->
          <!-- VER SI ES PARA CUANDO HACE ANALISIS DE LAB O PLATAFORMA. Posibles disbalances detectados: -->
          <!-- CASO A)----- DESBALANCES SEGUN LABORATORIO CIENTIFICO -->
          <div class="pl-10 pt-8 boxx" v-if="labs != ''">
            <div class="flex items-center">
              <div class="w-2 h-2 bg-gray-600 rounded-full mr-5 circlesinrelleno"></div>
              <span class="text-lg font-bold w-full">{{ $t("views.pdf.text8") }}</span>
            </div>
            <!--SUB ITEM -->
            <div class="pl-10 pt-8">
              <div class="flex boxx">
                <!--  Circulo sin relleno -->
                <div
                  class="w-2 h-2 border-1 border-gray-600 bg-transparent rounded-full mr-5 mt-2 circlesinrelleno"
                ></div>
                <div class="flex">
                  <!--  DISBALANCES FALTA HACERLO COMO LISTA -->
                  <span class="w-full">{{ labs }} </span>
                </div>
              </div>
            </div>
          </div>
          <!-- CASO B)--- DISBALANCES SEGUN UNICAMENTE LA PLATAFORMA -->
          <div class="pl-10 pt-8 boxx" v-else-if="user.imbalances != ''">
            <!-- POSIBLES DISBALANCES DETECTADOS -->
            <div class="flex items-center">
              <div class="w-2 h-2 bg-gray-600 rounded-full mr-5 circlesinrelleno"></div>
              <span class="text-lg font-bold w-full">{{ $t("views.pdf.text34") }}</span>
            </div>
            <div class="pl-10 pt-8">
              <div class="flex">
                <div
                  class="w-2 h-2 border-1 border-gray-600 bg-transparent rounded-full mr-5 mt-2 circlesinrelleno"
                ></div>
                <span class="w-full" v-html="$t('views.pdf.text32')"></span>
              </div>
            </div>
            <!-- ITEMS DISBALANCES DETECTADOS -->
            <div class="w-full pt-5 pl-10">
              <ul class="pl-7">
                <li v-for="(imbalance, index) in user.imbalances" :key="index" class="flex w-full mt-3 items-center">
                  <div class="w-2 h-2 mr-3 rounded-sm bg-gray-600"></div>
                  <span class="text-white imbalance px-2 py-1 font-bold text-[12px] leading-tight">
                    {{ imbalance }}
                  </span>
                </li>
              </ul>
            </div>
            <!-- Descripciones de DISBALANCES DETECTADOS -->
            <div class="pt-5 pl-10 w-full">
              <div class="flex flex-col" v-for="it in imbalancesTexts" :key="it.key">
                <div class="flex items-center mt-8">
                  <div class="w-2 h-2 mr-4 circlesinrelleno" style="background-color: #b4221b"></div>
                  <h3 class="font-bold pl-2 pr-2 imbalance">
                    {{ it.title }}
                  </h3>
                </div>

                <p class="pl-6 mt-4" v-html="it.text"></p>

                <ol v-if="it.tips.length > 0" class="custom-list pl-12 mt-8">
                  <li v-for="tip in it.tips" :key="tip.key">
                    <span v-html="tip.text"></span>
                  </li>
                </ol>
              </div>
            </div>
          </div>

          <!-- Title: Recomendaciones sobre:-->
          <div class="pl-10 pt-8 beforeClass">
            <div class="flex items-center boxx">
              <div class="w-2 h-2 bg-gray-600 rounded-full mr-5 circlesinrelleno"></div>
              <!--   Recomendaciones sobre -->
              <span class="text-lg font-bold">{{ $t("views.pdf.text9") }}</span>
            </div>
            <!-- 1 FOR, IMPORTANTE ENTENDER QUE FOODS TIENE UNA ESTRUCTURA DIFERENTE AL RESTO -->
            <!-- Bucle para recorrer todas las categorías en recommendations -->
            <template v-for="(category, categoryKey) in recommendations" :key="categoryKey">
              <div class="pl-10 mb-2" v-if="category.items.length > 0">
                <div class="flex pt-9 mb-3">
                  <div
                    class="w-2 h-2 border-1 border-gray-600 bg-transparent rounded-full mr-5 mt-1 circlesinrelleno"
                  ></div>
                  <!-- title: Alimentacion-->
                  <span class="w-full font-bold font-size" v-html="category.title"></span>
                </div>

                <div class="flex items-center mb-6 pt-2 pl-7" v-if="category.subtitle">
                  <p v-html="category.subtitle"></p>
                </div>

                <!-- 2 FOR-->
                <template v-for="(subitem, subitemKey) in category.items" :key="subitemKey">
                  <div class="pl-7" v-if="subitem.items.length > 0 && hasItems(subitem.items, categoryKey)">
                    <!-- VER: poner v-if si tiene alimentos a reducir/suspender -->
                    <div
                      v-if="subitem.items"
                      class="flex boxx"
                      :class="categoryKey === 'foods' && subitemKey > 0 ? ' pt-10' : ' pt-2'"
                    >
                      <!--   Cuadrado de los sup -->
                      <div class="size bg-gray-600 mr-4 mt-2 circlesinrelleno" v-if="subitem.title"></div>
                      <!-- Texto debajo de categoria solo si tiene -->
                      <span class="w-full textcuadrado" v-html="subitem.title"></span>
                    </div>

                    <!-- espacio suplementos -->
                    <div v-if="subitem.title == $t('views.pdf.text37')" class="espacio2"></div>

                    <div class="pl-6" v-if="subitem.items.length > 0 && typeof subitem.items[0] === 'object'">
                      <!-- 3 FOR-->
                      <template v-for="(subI, subIKey) in subitem.items" :key="subIKey">
                        <div
                          class="flex boxx items-center"
                          :class="categoryKey === 'foods' ? 'pt-6 pb-4' : ''"
                          v-if="hasItems(subI.items, categoryKey) && subI.items.length > 0"
                        >
                          <!-- circulo gris pintado, categorias por ejemplo: "ejercicio que te recomendamos realizar" -->
                          <div class="w-2 h-2 bg-gray-600 rounded-full mr-3 circlesinrelleno"></div>
                          <span class="w-full font-bold">{{ subI.title }} </span>

                          <!--  <span class="w-full font-bold" v-html="subI.title"></span>-->
                        </div>
                        <!-- Espacio puntual para suplemetno-->
                        <div
                          v-if="
                            subI.title === $t('views.pdf.text15') ||
                            categoryKey === 'exercisesdata' ||
                            categoryKey === 'sports' ||
                            categoryKey === 'lab'
                          "
                          class="espacio"
                        ></div>
                        <!-- 4 FOR-->
                        <!-- Subtítulo solo para LABORATORIO  -->
                        <p
                          v-if="categoryKey === 'lab' && subitemKey === 0"
                          class="pl-6 pt-2 text-sm"
                          v-html="$t('views.pdf.text66')"
                        ></p>

                        <template v-for="(subII, subIIKey) in subI.items" :key="subIIKey">
                          <div v-if="typeof subII === 'object' && subII.items.length > 0" class="mt-2">
                            <div class="flex pl-10 boxx items-center mt-4">
                              <!-- circulo sin relleno subtitulos dentro de una categoria -->
                              <div
                                class="w-2 h-2 border-2 border-gray-500 bg-transparent rounded-full mr-3 circlesinrelleno"
                              ></div>
                              <span class="w-full text-sm font-bold">{{ subII.title }}</span>
                            </div>
                            <div class="mt-5 mb-9 pl-8">
                              <!-- 5 FOR-->
                              <template v-for="(subIII, subIIIKey) in subII.items" :key="subIIKey">
                                <!-- subitem de las sub categorias -->
                                <div class="flex mt-2 pl-7 boxx items-center">
                                  <div
                                    class="w-1.5 h-1.5 mr-4 mt-0 circlesinrelleno"
                                    style="background-color: #131a29"
                                  ></div>
                                  <div :data-type="subitemKey" class="color__recommendation">{{ subIII }}</div>
                                </div>
                              </template>
                            </div>
                          </div>

                          <div v-if="typeof subII !== 'object'" class="flex mt-2 pl-10 boxx items-center">
                            <div
                              v-if="categoryKey != 'supplemnts'"
                              class="w-2 h-2 border-1 border-gray-600 bg-transparent rounded-full mr-5 circlesinrelleno"
                            ></div>
                            <div v-else class="w-2 mr-5">{{ subIIKey + 1 }}.</div>

                            <span class="w-full">{{ subII }}</span>
                          </div>
                        </template>
                      </template>

                      <div
                        :class="
                          categoryKey === 'supplemnts' ||
                          categoryKey === 'exercisesdata' ||
                          categoryKey === 'sports' ||
                          categoryKey === 'lab'
                            ? 'espacio3'
                            : ''
                        "
                      ></div>
                    </div>

                    <div class="pl-10 mb-10" v-else-if="subitem.items.length > 0">
                      <template v-for="(subI, subIKey) in subitem.items" :key="subIKey">
                        <div class="flex boxx mt-6">
                          <div class="w-2 h-2 bg-gray-500 rounded-full mt-2 mr-5 circlesinrelleno"></div>
                          <span class="w-full" v-html="subI"></span>
                        </div>
                      </template>
                    </div>
                  </div>
                </template>

                <div v-if="category.title === $t('views.pdf.text11')" class="mb-10 pl-10 pt-5">
                  <div class="flex boxx mb-6">
                    <div class="size bg-gray-600 mr-4 mt-1"></div>
                    <p class="w-full" v-html="$t('views.foodfinal.text0')"></p>
                  </div>
                  <ol class="pl-10 mb-8 mt-9">
                    <li class="align mt-5" v-for="(text, index) in Object.values(foodfinal).slice(1)" :key="index">
                      <div class="w-2 h-2 bg-gray-600 rounded-full circlesinrelleno mr-5 mt-1.5"></div>
                      <span class="w-full" v-html="text"></span>
                    </li>
                  </ol>
                  <template>
                    <div class="flex mt-4 boxx">
                      <div class="w-2 h-2 bg-gray-600 rounded-full mt-1 mr-5 circlesinrelleno"></div>
                      <span class="w-full" v-html="subI"></span>
                    </div>
                  </template>
                </div>
              </div>
            </template>
          </div>
          <div class="pl-10 mt-10">
            <div class="flex">
              <div class="w-2 h-2 rounded-full mr-5"></div>
              <span class="italic">{{ $t("views.pdf.text67") }}</span>
            </div>
          </div>
          <div class="pl-10 mt-8 hidden boxx">
            <div class="flex items-center">
              <div class="w-2 h-2 bg-gray-600 rounded-full mr-5 circlesinrelleno"></div>
              <span class="text-lg italic-text">{{ $t("views.pdf.text10") }}</span>
            </div>
            <div class="pl-10 mt-3">
              <div class="flex">
                <div
                  class="w-2 h-2 border-1 border-gray-600 bg-transparent rounded-full mr-5 mt-2 circlesinrelleno"
                ></div>
                <span class="w-full">{{ conclusions }}</span>
              </div>
            </div>
          </div>
        </template>
        <div v-if="!loaded || !loadedLabs" class="mt-5">
          {{ $t("views.loading") }}
          <LoadingIcon icon="three-dots" color="currentColor" class="ml-4 inline-block" />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
@keyframes blink {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

.textcuadrado {
  font-size: 15px;
}

.blinking {
  animation: blink 1s linear infinite;
}

.circlesinrelleno {
  aspect-ratio: 1 / 1;
}

.cursor {
  cursor: pointer !important;
}

.table td.p-0 {
  padding: 0px !important;
}
</style>

<style>
.font-size {
  font-size: medium;
}

.imbalance {
  font-weight: 700;
  background-color: #d22c23;
  color: white;
}

.align {
  display: flex;
  align-items: flex-start;
  margin-top: 10px;
}

.espacio3 {
  height: 40px;
}

.espacio2 {
  height: 20px;
}

.espacio {
  height: 12px;
}

.size {
  width: 8px;
  height: 8px;
}

.custom-list {
  list-style-type: none;
  /* Remueve el estilo predeterminado */
  counter-reset: custom-counter;
  /* Inicializa un contador personalizado */
  padding-left: 0;
}

.custom-list li {
  position: relative;
  counter-increment: custom-counter;
  /* Incrementa el contador para cada elemento li */
  margin-bottom: 20px;
}

.custom-list li:before {
  content: counter(custom-counter) ". ";
  margin-right: 6px;
  min-width: 20px;
  text-align: right;
  position: absolute;
  /* Posicionamiento absoluto respecto al li */
  left: -30px;
  /* Ajusta la posición a la izquierda del contenido del li */
  top: 0;
}

.pad {
  padding-right: 8px;
  padding-left: 8px;
}

.tom-select .ts-dropdown .option.active {
  background: #6c869a !important;
}

.top-bar .breadcrumb > a:not(.breadcrumb--active) {
  color: #6c869a !important;
}

.detail-food {
  display: grid;
  grid-auto-columns: 1fr 1fr 1fr 1fr;
  grid-column-gap: 2em;
  grid-row-gap: initial;
  -ms-grid-columns: 1fr 1fr 1fr 1fr;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  -ms-grid-rows: auto;
  grid-template-rows: auto;
}

.pagination li,
.pagination a,
.pagination a:focus,
.pagination a:active {
  outline: none !important;
}

.color__recommendation,
.highlight {
  color: white;
  font-weight: 700;
}

.color__recommendation[data-type="0"] {
  background-color: #6aa84f;
}

.color__recommendation[data-type="1"] {
  background-color: #e69138;
}

.color__recommendation[data-type="2"] {
  background-color: #d22c23;
}

.highlight {
  width: auto;
}

.box {
  background-color: transparent;
}

.document {
  max-width: 790px;
}
</style>

<script>
import QuizService from "@/services/quiz.service";
import LabService from "@/services/lab.service";
import html2pdf from "@/assets/js/html2pdf.bundle.min.js";
import moment from "moment";
import viewData from "@/lang/locals/es/views.json";

export default {
  components: {},
  setup() {},
  // usamos option.
  data() {
    return {
      isContentReady: false,
      isDownloading: false,
      user: localStorage.userItem ? JSON.parse(localStorage.userItem) : {},
      today: moment().format("DD/MM/YYYY"),
      recommendations: {},
      conclusions: "",
      loaded: false,
      loadedLabs: false,
      labs: "",
      break: 35,
      itemDescriptions: viewData.itemDescriptions,
      foodfinal: viewData.foodfinal,
      healthAssessments: {
        imbalances: [],
        digestiveDisorders: [],
      },
      pdf: viewData.pdf,
      viewContent: viewData,
    };
  },
  //  watch se utiliza para efectuar acciones en respuesta a un cambio.
  watch: {
    isDownloading(newValue, oldValue) {
      console.log("isDownloading cambió de", oldValue, "a", newValue);
    },
    loaded: function () {
      if (this.loaded && this.loadedLabs) {
        this.setBreakPage();
      }
    },
    loadedLabs: function () {
      if (this.loaded && this.loadedLabs) {
        this.setBreakPage();
      }
    },
  },
  computed: {
    imbalancesTexts() {
      return this.user.imbalances
        .map((position) => {
          const key = this.getImbalanceKey(position);
          if (!key) return null;

          const textData = this.itemDescriptions[key];
          if (!textData) return null;

          const getTextByBiologicalSex = (text) => {
            if (text && typeof text === "object") {
              const biologicalSex = this.user.gender.toLowerCase();
              return text[biologicalSex] || text.male || text;
            }

            return text;
          };

          const tipsData = textData.tips || [];
          const tipsFormated = [];
          for (const i in tipsData) {
            const tip = tipsData[i];

            tipsFormated.push({
              key: i,
              text: getTextByBiologicalSex(tip),
            });
          }

          return {
            key,
            title: getTextByBiologicalSex(textData.title),
            text: getTextByBiologicalSex(textData.text),
            tips: tipsFormated,
            debug: textData,
          };
        })
        .filter(Boolean);
    },
    healthAssessmentsShow() {
      return this.healthAssessments.imbalances.length || this.healthAssessments.digestiveDisorders.length;
    },
  },
  //  Este método se ejecuta cuando el componente se ha creado, pero antes de que se monte en el DOM.
  created() {
    window.vue = this;
    this.getQuizId();
  },
  mounted() {
    console.log(this.user.gender);
    this.user.num_analysis = "00000369";
    this.recommendations = {
      //   healthGoals : {
      //         title : " Secciones de la plataforma que te recomendamos recorrer para mejorar tu perfil de salud:",
      //         items: []
      //   },
      foods: {
        title: this.$t("views.pdf.text11"),
        subtitle: this.$t("views.pdf.text33"),
        class: "",
        items: [
          {
            title: this.$t("views.pdf.text12"),
            items: [],
          },
          {
            title: this.$t("views.pdf.text13"),
            items: [],
          },
          {
            title: this.$t("views.pdf.text14"),
            items: [],
          },
        ],
      },

      supplemnts: {
        title: this.$t("views.pdf.text36"),
        subtitle: this.$t("views.pdf.text35"),
        items: [
          {
            // title: this.$t("views.pdf.text35"), tu titleone
            items: [
              {
                // sugeridos
                title: this.$t("views.pdf.text15"),
                items: [],
              },
              {
                // suspender
                title: this.$t("views.pdf.text16"),
                items: [],
              },
              {
                // reducir
                title: this.$t("views.pdf.text17"),
                items: [],
              },
            ],
          },
          {
            title: this.$t("views.pdf.text37"),
            items: [
              this.$t("views.pdf.text38"),
              this.$t("views.pdf.text39"),
              this.$t("views.pdf.text40"),
              this.$t("views.pdf.text41"),
              this.$t("views.pdf.text42"),
              this.$t("views.pdf.text43"),
            ],
          },
        ],
      },
      exercisesdata: {
        title: this.$t("views.pdf.text48"),
        subtitle: this.$t("views.pdf.text46"),
        items: [
          {
            items: [
              {
                // sugeridos
                title: this.$t("views.pdf.text18"),
                items: [],
              },
              {
                // suspender
                title: this.$t("views.pdf.text20"),
                items: [],
              },
              {
                // reducir
                title: this.$t("views.pdf.text19"),
                items: [],
              },
            ],
          },
          {
            title: this.$t("views.pdf.text49"), // tu titlethree
            items: [
              this.$t("views.pdf.text50"), // titlefour.0
              this.$t("views.pdf.text51"), // titlefour.1
              this.$t("views.pdf.text52"), // titlefour.2
              this.$t("views.pdf.text53"), // titlefour.3
              this.$t("views.pdf.text54"), // titlefour.4
              this.$t("views.pdf.text55"), // titlefour.5
            ],
          },
        ],
        class: "",
      },
      // ANTES:exercisesToReduce: {
      // title: this.$t("views.pdf.text19"),
      // items: []
      // },
      // ANTES: exercisesToSuspend: {
      // title: this.$t("views.pdf.text20"),
      // items: []
      // },
      sports: {
        title: this.$t("views.pdf.text29"),
        subtitle: this.$t("views.pdf.text47"),
        items: [],
        class: "",
      },
      lab: {
        title: this.$t("views.pdf.text57"),
        subtitle: this.$t("views.pdf.text56"),
        items: [
          {
            items: [
              {
                title: this.$t("views.pdf.text21"),
                items: [],
              },
            ],
          },
          {
            title: this.$t("views.pdf.text58"), // tu titlethree
            items: [
              this.$t("views.pdf.text60"),
              this.$t("views.pdf.text61"), // titlefour.1
              this.$t("views.pdf.text62"), // titlefour.2
              this.$t("views.pdf.text63"), // titlefour.3
              this.$t("views.pdf.text64"), // titlefour.4
              this.$t("views.pdf.text65"), // titlefour.5
            ],
          },
        ],
      },
    };

    this.conclusions = ``;
    this.resetHealthAssessments();
  },
  methods: {
    resetHealthAssessments() {
      this.healthAssessments = {
        imbalances: [],
        digestiveDisorders: [],
      };
    },

    getImbalanceKey(position) {
      if (!position) return null;

      const map = {
        // Estrogen
        Estrógeno: "estrogen",
        estrogen: "estrogen",
        ESTROGEN: "estrogen",

        // Insulin
        Insulina: "insulin",
        insulin: "insulin",
        INSULIN: "insulin",

        // Cortisol
        Cortisol: "cortisol",
        cortisol: "cortisol",
        CORTISOL: "cortisol",

        // Testosterone
        Testosterona: "testosterone",
        testosterone: "testosterone",
        TESTOSTERONE: "testosterone",

        // Thyroid hormone
        Tiroides: "thyroid_hormone",
        Tiroide: "thyroid_hormone",
        "Hormona tiroidea": "thyroid_hormone",
        "Hormonas tiroideas": "thyroid_hormone",
        thyroid_hormone: "thyroid_hormone",
        THYROID_HORMONES: "thyroid_hormone",

        // Symptom of parasites
        "Síntomas de parásitos": "parasite_symptoms",
        parasite_symptoms: "parasite_symptoms",

        // Symptom of candida
        "Síntomas de candida": "candida_symptoms",
        candida_symptoms: "candida_symptoms",
      };

      return map[position] || null;
    },
    getQuizId() {
      QuizService.getQuizMenuToEdit({
        // le pasas el dato del usuario puntual
        user_id: this.user.id,
      }).then((response) => {
        var quizzes = [];
        var quizzesInfo = [];
        response.map((item) => {
          // si item tiene un quiz id
          // cada item es un objeto dentro del array
          if (item.quiz_id) {
            // se crea un nuevo objeto con ese quiz id, se lo agrega al array de quizzes.
            quizzes.push({ quiz_id: item.quiz_id });
            quizzesInfo.push({ quiz_id: item.quiz_id, title: item.title });
          }
          // esto se fija si el cuestionario actual tiene subcuestionarios
          if (item.quizzes) {
            item.quizzes.map((a) => {
              if (a.quiz_id) {
                quizzes.push({ quiz_id: a.quiz_id });
                quizzesInfo.push({ quiz_id: a.quiz_id, title: a.title });
              }
              if (a.quizzes) {
                a.quizzes.map((b) => {
                  if (b.quiz_id) {
                    quizzes.push({ quiz_id: b.quiz_id });
                    quizzesInfo.push({ quiz_id: b.quiz_id, title: b.title });
                  }
                });
              }
            });
          }
        });
        console.log(quizzes);
        // ver el titulo
        this.getRecommendations(quizzes);
        this.getLabs();
      });
    },
    async getRecommendations(quizzes) {
      var data = await QuizService.getRecommendationsPdf({
        user_id: this.user.id,
        // filter: quizzes,
        clear_cache: 1, // Indica que se debe ignorar la caché y obtener datos frescos
        client_hour: 23,
        hour: 23,
      });
      console.log("\n\ndata: ", data);
      /** healthGoals */
      // this.recommendations.healthGoals.items = data.healthGoals.map(hG => { return {title : hG.name, items: []}})
      /** healthGoals */

      /** Foods */
      var foods = data.foodTree;

      foods = this.sortGroupFoods(foods, "ADD", true);
      console.log("FOODS: ", foods);
      this.recommendations.foods.items[0].items = foods;

      foods = data.foodTree;
      foods = this.sortGroupFoods(foods, "REDUCE");
      this.recommendations.foods.items[1].items = foods;

      foods = data.foodTree;
      foods = this.sortGroupFoods(foods, "SUSPEND");
      this.recommendations.foods.items[2].items = foods;
      // this.recommendations.foods = data.foodTree

      /** Foods */

      /** Supplements */
      var supplemnts = data.supplements; // .filter(s => s.increase === true)

      this.recommendations.supplemnts.items[0].items[0].items = supplemnts.map((s) => {
        return s.name;
      });

      this.recommendations.supplemnts.items[0].items[1].items = (data.supplements_to_suspend || []).map((s) => {
        return { title: s.name, items: [] };
      });

      this.recommendations.supplemnts.items[0].items[2].items = (data.supplements_to_reduce || []).map((s) => {
        return { title: s.name, items: [] };
      });
      /** Supplements */

      /** Exercise */

      this.recommendations.exercisesdata.items[0].items[0].items = data.suggested_exercises.map((s) => {
        return s.name;
      });
      this.recommendations.exercisesdata.items[0].items[1].items = (data.exercisesToSuspend || []).map((s) => {
        return { title: s.name, items: [] };
      });
      this.recommendations.exercisesdata.items[0].items[2].items = (data.exercisesToReduce || []).map((s) => {
        return { title: s.name, items: [] };
      });
      /** Sports */
      this.recommendations.sports.items = [
        {
          items: data.suggested_sports.map((s) => s.name),
        },
      ];

      console.log(this.recommendations.sports.items);
      // Este data se usa unicamente aca. la funcion del quiz.service..js sobreescribe data para obtener lab items.
      data = await QuizService.getRecommendations({
        user_id: this.user.id,
        filter: quizzes,
      });

      /** LAB ITEMS */
      this.recommendations.lab.items[0].items[0].items = data.labItems.map((s) => {
        return s.name;
      });
      /** TERMINA LAB ITEMS */

      this.loaded = true;
    },

    async getLabs(quizzes) {
      var data = await LabService.getUserLabResult({
        user_id: this.user.id,
      });
      if (data && data.length > 0) var notShow = ["SUBOPTIMO_BAJO", "OPTIMO", "SUBOPTIMO_ALTO"];
      var labs = data[0].filter((lab) => !notShow.includes(lab.result));
      labs = labs.map((l) => l.lab_item_name);
      this.labs = labs.join(", ");

      // Si no se tiene labs, se pregunta por los disbalances segun la plataforma funcional
      if (labs == "") {
        await this.getHealthAssessments();
      }

      this.loadedLabs = true;
      console.log("loadedLabs es true");
    },

    async getHealthAssessments() {
      const userId = this.user.id;

      const result = await QuizService.getHealthAssessments(userId);
      if (!result.success) {
        this.resetHealthAssessments();
        return;
      }

      const { imbalance = [], digestive_disorders: digestiveDisorders = [] } = result.data;

      this.healthAssessments.imbalances = imbalance;
      this.healthAssessments.digestiveDisorders = digestiveDisorders;

      console.log("healthAssessments", this.healthAssessments);
    },

    // generateReport() {
    //  html2pdf(this.$refs.document, {
    //   margin: [0.8, 0],
    //    filename: "ilongevity.pdf",
    //    image: { type: "jpeg", quality: 0.98 },
    //  html2canvas: { dpi: 192, letterRendering: true },
    // jsPDF: { unit: "in", format: "A4" },
    //   pagebreak: { before: ".beforeClass" } //mode : ['css', 'legacy'],
    // })
    // },
    generateReport() {
      this.isDownloading = true;
      console.log("Intentando generar el PDF");
      // Asegurarse de que todo está cargado antes de intentar generar el PDF.
      try {
        console.log("datos pdf:", this.$refs.document);
        html2pdf()
          .set({
            html2canvas: {
              // width: this.$refs.document.offsetWidth,
              // height: this.$refs.document.offsetHeight,
              dpi: 192,
              letterRendering: true,
            },
            margin: [0.8, 0],
            filename: "ilongevity.pdf",
            image: { type: "jpeg", quality: 0.98 },
            jsPDF: {
              unit: "in",
              format: "A4",
              orientation: "portrait",
            },
            pagebreak: { before: ".beforeClass" },
          })
          .from(this.$refs.document)
          .toPdf()
          .get("pdf")
          .then(function (pdf) {
            console.log("PDF generado con éxito");
          })
          .save()

          .then(() => {
            this.isDownloading = false; // Detener el titileo
          })
          .catch((error) => {
            console.error("Se produjo un error al generar el PDF:", error);
            this.isDownloading = false; // Asegurarse de detener el titileo en caso de error
          });
      } catch (error) {
        console.error("Error al ejecutar html2pdf:", error);
      }
    },
    preventClick() {
      // Aquí puedes manejar un clic no deseado, como mostrar un mensaje.
      console.log("El contenido no está listo para la descarga.");
    },
    // Ordenamiento de los alimentos
    sortGroupFoods(foods, type, primary = false) {
      // La posición en el array de items dentro de foods son:
      // 0 == agregar
      // 1 == reducir
      // 2 == eliminar
      var catGroups = [
        { title: this.$t("views.pdf.text22"), id: "meats", items: [] },
        { title: this.$t("views.pdf.text23"), id: "condiments_spices", items: [] },
        { title: this.$t("views.pdf.text24"), id: "fish_seafood", items: [] },
        { title: this.$t("views.pdf.text25"), id: "fruits", items: [] },
        { title: this.$t("views.pdf.text27"), id: "grains_seeds", items: [] },
        { title: this.$t("views.pdf.text26"), id: "vegetables", items: [] },
        { title: this.$t("views.pdf.text28"), id: "animal_origin", items: [] },
        { title: this.$t("views.pdf.text45"), id: "drinks", items: [] },
      ];
      const catNotInclude = primary ? [64, 809] : []; // Cereales
      const foodNotInclude = primary ? [809] : []; // Soja
      function compareName(a, b) {
        if (a < b) return -1;
        if (a > b) return 1;
        return 0;
      }

      catGroups.map((catGroup) => {
        if (foods.hasOwnProperty(catGroup.id)) {
          catGroup.items = foods[catGroup.id].items.find((f) => f.type === type).items;

          catGroup.items = catGroup.items.filter((it) => it.items.length > 0);

          catGroup.items = catGroup.items.map((f) => {
            f.title = f.category_name;
            return f;
          });

          catGroup.items = catGroup.items.map((f) => {
            f.items = f.items.map((it) => it.name);
            f.items.sort(compareName);
            return f;
          });
          // catGroup.items.sort(compareName)
        }

        return catGroup;
      });

      return catGroups;
    },
    // vieja
    // setBreakPage() {
    //   var h = 0;
    // setTimeout(function () {
    // var boxes = document.getElementsByClassName("boxx");
    //   for (let i = 0; i < boxes.length; i++) {
    //    let style = getComputedStyle(boxes[i]);
    //    let mt = parseInt(style.marginTop);
    //     h = h + boxes[i].offsetHeight + mt;
    //    if (h >= 900) {
    //      boxes[i].classList.add("beforeClass");
    //      boxes[i].classList.add(h);
    //      h = 0;
    //    }
    //  }
    // }, 60);
    //   },

    setBreakPage() {
      let alturaAcumuladaPx = 0; // Inicializa la altura acumulada en 0
      const alturaMaximaPx = 969; // Define la altura máxima utilizable en píxeles
      const boxes = document.getElementsByClassName("boxx");

      for (let i = 0; i < boxes.length; i++) {
        const estilo = getComputedStyle(boxes[i]);
        const margenSuperiorPx = parseInt(estilo.marginTop, 10); // Obtiene el margen superior
        // Suma la altura del elemento actual y su margen superior a la altura acumulada
        alturaAcumuladaPx += boxes[i].offsetHeight + margenSuperiorPx;

        // Verifica si la altura acumulada excede la altura máxima permitida
        if (alturaAcumuladaPx >= alturaMaximaPx) {
          boxes[i].classList.add("beforeClass"); // Agrega la clase para indicar un salto de página
          // Reinicia la altura acumulada, contando la altura del elemento actual desde el principio para la próxima página
          alturaAcumuladaPx = boxes[i].offsetHeight + margenSuperiorPx;
        }
      }
    },
    hasItems(items, itemKey) {
      if (itemKey != "foods") return true;
      if (!items || items.length == 0) return false;

      var has = false;
      items.map((item) => {
        if (item.items.length > 0) {
          has = true;
        }
      });

      return has;
    },
  },
};
</script>
// try // const params = this.$route.params // Asumiendo uso de vue-router // // const response = await
SessionService.getAll({ user_id: this.user.id }) // const // rows = response.rows // console.log(this.user.imbalances)
// console.log(rows)
